import VideoTranscripts from "../../../common/videos/transcripts.js";
import ProdScroller4i from '../../../common/productscrollers.js';
import StarRating from '../../../common/starrating25.js';
import { InitCommon, ShowFromDialog, AddLinks } from "../shared.js";

function init(){
    VideoTranscripts.init();
    InitCommon(VideoTranscripts);
    initProductScrollers();
    ShowFromDialog();
    addMouseoverEvents();

    const detailsReviewLink = document.querySelector(".prodDetails .miniReviewLink");
    detailsReviewLink && detailsReviewLink.addEventListener("click", (e) => {
        e.preventDefault();
        StarRating.toggle(e);
    });

    setTimeout(() => { AddLinks(); }, 300);
}

function addMouseoverEvents(){
    const allVideoLinks = Array.from(document.querySelectorAll(".videoLink"));
    allVideoLinks.forEach(link => {
        link.addEventListener("mouseover", makeTransparent);
        link.addEventListener("mouseout", undoTransparent);
    });
}

function initProductScrollers() {
    const newVids = document.getElementById("newVideos");
    if(newVids !== null) {
        const scroller = new ProdScroller4i();
        scroller.init(newVids.id, 5, 4, 3);
    }
    const hotVids = document.getElementById("hotVideos");
    if(hotVids !== null) {
        const scroller = new ProdScroller4i();
        scroller.init(hotVids.id, 5, 4, 3);
    }
    const saleVids = document.getElementById("saleVideos");
    if(saleVids !== null) {
        const scroller = new ProdScroller4i();
        scroller.init(saleVids.id, 5, 4, 3);
    }
}

function makeTransparent(e) {
    const el = e.currentTarget;
    const itemImage = el.querySelector(".thumbImg");
    itemImage.style.opacity = "0.3";
}

function undoTransparent(e) {
    const el = e.currentTarget;
    const itemImage = el.querySelector(".thumbImg");
    itemImage.style.opacity = "1";
}

init();